export default "__VITE_ASSET__ebad55a9__"